import ExaminationCreation from './ExaminationCreation';

export default ExaminationCreation;
